import styled, { StyledComponent } from 'styled-components'
import Button from './Button'
import Description from './Description'
import Title from './Title'
import { ButtonProps } from '../../elements/Button'
import { Views } from '../../../enums'

const Heading = styled.div<HeadingProps>`
  margin-right: auto;
  margin-left: auto;
  padding-top: ${({ view }) => view === Views.default ? `10px` : `20px`};
  padding-bottom: 10px;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media(max-width: 767px) {
    padding-top: 7px;
    padding-bottom: 7px;
    height: auto;
    max-height: 25%
    justify-content: flex-start;
  }
` as Heading

Heading.Button = Button
Heading.Description = Description
Heading.Title = Title

export default Heading

type Heading = StyledComponent<'div', HeadingProps, any> & {
  Button: StyledComponent<'div', ButtonProps, any>
  Description: StyledComponent<'p', any>
  Title: StyledComponent<'p', any>
}

interface HeadingProps {
  view: Views
}


